import { ApiServices } from "./apiServices";
import { buildUrl, showToast } from "./utils";
import * as customizationUrl from "pages/Document-Customization/utils/urlHelper";

// for getting customizationData
export const getCustomizationDataByKey = async (queryParams) => {
  try {

    let result = await ApiServices.callServiceGet(
      buildUrl(customizationUrl?.GET, queryParams)
    );

    if (result?.meta?.success) {
      return result?.data;
    } else {
      // showToast(result);
    }
  } catch (error) {
    console.error(error);
  }
};


// for updating customizationData
export const updateCustomizationData = async (reqObj) => {
  try {
    let result = await ApiServices.callServicePutWithBodyData(
      customizationUrl?.UPDATE, reqObj
    );
    if (result?.meta?.success) {
      return result?.data;
    } else {
      if (!reqObj?.isCurrent) {
        showToast(result);
      }
    }
  } catch (error) {
    console.error(error);
  }
};
